import { editUser, UserInfo } from "../../../../services/userService";
import { AppDispatch } from "../../../../store/store";
import "./AccountSettings.scss";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const AccountSettings = ({
  userInfo,
  access_token,
}: {
  userInfo?: UserInfo;
  access_token: string | null;
}) => {
  const [form, setForm] = useState<Partial<UserInfo> | undefined>(undefined);
  const dispatch = useDispatch<AppDispatch>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (form && access_token)
      dispatch(editUser({ userInfo: form, token: access_token }));
  };

  useEffect(() => {
    if (userInfo?.id && !form)
      setForm({
        lastName: userInfo?.lastName,
        firstName: userInfo?.firstName,
        companyName: userInfo?.companyName,
        username: userInfo?.username,
      });
  }, [userInfo, userInfo?.id, form]);

  return (
    <div className="form-section">
      <h2>Mes informations</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="lastName"
          value={form?.lastName}
          onChange={handleChange}
          placeholder="Nom"
        />
        <input
          type="text"
          name="firstName"
          value={form?.firstName}
          onChange={handleChange}
          placeholder="Prénom"
        />
        <input
          type="text"
          name="companyName"
          value={form?.companyName}
          onChange={handleChange}
          placeholder="Entreprise"
        />
        <input
          type="text"
          name="username"
          value={form?.username}
          onChange={handleChange}
          placeholder="Pseudo"
        />
        <div>
          <button type="submit">Enregistrer</button>
        </div>
      </form>
    </div>
  );
};

export default AccountSettings;
